module.exports = {
    handle: (e, data) => {           
        console.log('eec:internalPromotionImpressions:handler');
    }
}